import { Navigate, Route, Routes } from 'react-router-dom';

import { GoodsPage, ResultPage } from '../pages';
import { MainPage } from '../pages';

export const HomeRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<MainPage />} />
            <Route path="/pouches-result" element={<ResultPage />} />
            <Route path="/goods" element={<GoodsPage />} />
            <Route path="/goods/:id" element={<GoodsPage />} />
            <Route path="*" element={<Navigate to="/home"></Navigate>} />
        </Routes>
    );
};
